import React, { useState } from "react";
import styles from "./CreateFolderCard.module.css";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice"; // Adjust path as needed

const CreateFolderCard = () => {
  const [folderName, setFolderName] = useState("");
  const dispatch = useDispatch();

  const handleSubmit = () => {
    if (folderName.trim() !== "") {
      console.log("Folder Created:", folderName);
      // Optional: dispatch(createFolder(folderName));
      setFolderName("");
      dispatch(closeModal());
    } else {
      alert("Please enter a folder name.");
    }
  };

  const handleCancel = () => {
    console.log("Folder creation cancelled");
    dispatch(closeModal());
  };

  return (
    <div className={styles.cardContainer}>
      <div className={styles.cardHeader}>Input Folder Name</div>
      <div className={styles.cardBody}>
        <input
          type="text"
          className={styles.inputBox}
          placeholder="Enter folder name"
          value={folderName}
          onChange={(e) => setFolderName(e.target.value)}
        />
        <div className={styles.buttonRow}>
          <button className={styles.cancelBtn} onClick={handleCancel}>
            Cancel
          </button>
          <button className={styles.updateBtn} onClick={handleSubmit}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateFolderCard;
